var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogowhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1602,
    height: 145,
    viewBox: "0 0 1602 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.511 140.639V119.889H66.5661C60.2434 119.889 53.8829 118.591 48.6052 115.109C11.4264 90.5821 20.3039 46.8638 47.9432 30.8758C53.602 27.6024 60.2801 26.9 66.8175 26.9H130.701V4.61328H62.6146C57.4138 4.61328 52.2477 5.45992 47.319 7.11997C19.3466 16.5413 1.07607 43.4435 2.6319 72.9189L3.17504 83.2086C4.35865 105.632 18.2843 125.395 39.0025 134.053C49.4049 138.401 60.5669 140.639 71.8412 140.639H128.511Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.243 141.408H151.877L216.132 4.61328H235.117L299.372 141.408H276.006L225.624 30.8902L175.243 141.408Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M718.492 141.408H695.126L759.381 4.61328H778.366L842.621 141.408H819.255L768.874 30.8902L718.492 141.408Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M925.859 141.408V60.8944H949.868V64.8028H1046.58V85.1266H949.868V141.408H925.859Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.49 26.1315H925.859V4.61328H1049.49V26.1315Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.75 4.61328H1085.04V141.408H1196.75V120.658H1104.75V4.61328Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1447.38 136.385L1396.09 8.45582H1418L1456.27 109.527C1456.92 111.255 1459.37 111.248 1460.01 109.516L1495.33 14.5999C1496.62 11.1372 1501.51 11.1229 1502.82 14.5781L1538.27 108.187C1538.93 109.914 1541.37 109.907 1542.02 108.175L1579.59 7.11681L1602 8.45582L1549.28 136.455C1548.04 139.452 1545.12 141.408 1541.88 141.408H1534.62C1531.24 141.408 1528.22 139.283 1527.09 136.1L1499.98 60.2435C1499.66 59.3625 1498.42 59.3577 1498.1 60.2363L1470.3 136.158C1469.15 139.311 1466.15 141.408 1462.79 141.408H1454.81C1451.54 141.408 1448.6 139.419 1447.38 136.385Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M357.056 141.406H333.69V66.8606H357.056V73.7771H418.701C431.434 73.7771 441.756 63.455 441.756 50.7219C441.756 37.9888 431.434 27.6667 418.701 27.6667H333.69V6.14844H416.143C441.333 6.14844 461.518 27.0057 460.693 52.1815C459.905 76.2176 440.192 95.2954 416.143 95.2954H357.056V141.406Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M515.504 6.14844H495.789V141.406H515.504V6.14844Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M606.775 27.6667H554.933V6.14844H680.523V27.6667H629.411V141.406H606.775V27.6667Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.19 72.2397C1374.19 112.137 1340.51 144.479 1298.98 144.479C1257.44 144.479 1223.77 112.137 1223.77 72.2397C1223.77 32.3428 1257.44 0 1298.98 0C1340.51 0 1374.19 32.3428 1374.19 72.2397ZM1247.11 72.2397C1247.11 99.7574 1270.33 119.119 1298.98 119.119C1327.63 119.119 1350.85 99.7574 1350.85 72.2397C1350.85 44.7221 1327.63 23.8237 1298.98 23.8237C1270.33 23.8237 1247.11 44.7221 1247.11 72.2397Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowhite);
export default __webpack_public_path__ + "static/media/logowhite.d0a9165e855399b8bf1788469b2cd14c.svg";
export { ForwardRef as ReactComponent };